import hoverintent from 'hoverintent';
/* eslint-disable */

$(".menu-toggler").keyup(function(event) {
  if (event.keyCode === 13) {    
    
    $('#toggle-online-menu').prop('checked', false);
    $('#toggle-reading-menu').prop('checked', false);
    if (document.getElementById('toggle').checked) {
        document.getElementById("toggle").checked = false;
        $(".menuLink.levelOne").attr('tabindex', -1); 
        $(".menuLink.levelTwo").attr('tabindex', -1);        
        $('body').css('overflow', 'hidden');

    } else {
        document.getElementById("toggle").checked = true;     
        $(".menuLink.levelOne").attr('tabindex', 0);
        $("#online-menu-expand").attr('tabindex', 0);
        $("#reading-menu-expand").attr('tabindex',0);
        $(".menuLink.levelTwo").attr('tabindex', -1);       
        $('body').css('overflow', 'auto');
    }
  }
});

var opts = {
  timeout: 700,
  interval: 70
};

const validate = function () {
    document.getElementById('toggle').onclick = function clickMenu() {
      
      $('#toggle-online-menu').prop('checked', false);
      $('#toggle-reading-menu').prop('checked', false);
      if (document.getElementById('toggle').checked) {
            $(".menuLink.levelOne").attr('tabindex', 0);
            $(".menuLink.levelTwo").attr('tabindex', 0);                      
            $('body').css('overflow', 'hidden');

        } else {   
            $(".menuLink.levelOne").attr('tabindex', -1);
            $(".menuLink.levelTwo").attr('tabindex', -1);
            $(".menuLink.levelTwo.levelTwoOnline").attr('tabindex', -1);
            $(".menuLink.levelTwo.levelTwoReading").attr('tabindex', -1);        
            $('body').css('overflow', 'auto');
        }
    };
};
validate();


const validate2 = function () { 

        document.getElementById('moreOnline').onclick = function onlineMenu() {
          
          //do something special
          $(".menuLink.levelOne").attr('tabindex', -1);  
          $(".menuLink.levelTwo.levelTwoOnline").attr('tabindex', 0);  
          $('#main-nav-scrollable').scrollTop(0);
          $('.full-online-menu').scrollTop(0);                         
          $('.second-level-menu.full-online-menu').css('overflow-y', 'auto');
          $('.menu-sidebar').css('overflow-y', 'hidden');
    
        };

        $('#online-menu-expand').keyup(function(event) {
          if (event.keyCode === 13) {
            //do something special
            document.getElementById('toggle-online-menu').checked = true;
            $(".menuLink.levelOne").attr('tabindex', -1);
            $("#online-menu-expand").attr('tabindex', -1);
            $('#reading-menu-expand').attr('tabindex', -1);
            $(".full-menu-back.full-menu-back-online").attr('tabindex', 0);   
            $(".menuLink.levelTwo.levelTwoOnline").attr('tabindex', 0); 
            $('#main-nav-scrollable').scrollTop(0);
            $('.full-online-menu').scrollTop(0);                         
            $('.second-level-menu.full-online-menu').css('overflow-y', 'auto');
            $('.menu-sidebar').css('overflow-y', 'hidden');            
          }
        });

        $(".full-menu-back.full-menu-back-online").keyup(function(event){
          if(event.keyCode === 13)
          {
            $(".menuLink.levelOne").attr('tabindex', 0);
            $("#online-menu-expand").attr('tabindex', 0);
            $('#reading-menu-expand').attr('tabindex', 0);
            $(".full-menu-back.full-menu-back-online").attr('tabindex', -1);   
            $(".menuLink.levelTwo.levelTwoOnline").attr('tabindex', -1); 
            $('#main-nav-scrollable').scrollTop(0);
            $('.full-online-menu').scrollTop(0);                         
            $('.second-level-menu.full-online-menu').css('overflow-y', 'auto');
            $('.menu-sidebar').css('overflow-y', 'hidden');
          }
        });

        document.getElementById('moreReadingRoom').onclick = function readingMenu() {
          $(".menuLink.levelOne").attr('tabindex', -1);  
          $(".menuLink.levelTwo.levelTwoReading").attr('tabindex', 0); 
          $('#main-nav-scrollable').scrollTop(0);
          $('.full-online-menu').scrollTop(0);   
          $('.second-level-menu.full-reading-menu').css('overflow-y', 'auto');
          $('.menu-sidebar').css('overflow-y', 'hidden');
    
        };


        $('#reading-menu-expand').keyup(function(event) {
          if (event.keyCode === 13) {
            //do something special
            document.getElementById('toggle-reading-menu').checked = true;
            $(".menuLink.levelOne").attr('tabindex', -1); 
            $("#online-menu-expand").attr('tabindex', -1);
            $('#reading-menu-expand').attr('tabindex', -1); 
            $(".menuLink.levelTwo.levelTwoReading").attr('tabindex', 0);
            $(".full-menu-back.full-menu-back-readingroom").attr('tabindex', 0); 
            $('#main-nav-scrollable').scrollTop(0);
            $('.full-online-menu').scrollTop(0);   
            $('.second-level-menu.full-reading-menu').css('overflow-y', 'auto');
            $('.menu-sidebar').css('overflow-y', 'hidden');        
          }
        });


        $('#moreReadingRoom').keyup(function(event) {
          if (event.keyCode === 13) {
            //do something special
            $('#main-nav-scrollable').scrollTop(0);
            $('.full-online-menu').scrollTop(0);                         
            $('.second-level-menu.full-online-menu').css('overflow-y', 'auto');
            $('.menu-sidebar').css('overflow-y', 'hidden');            
          }
        });

        $(".full-menu-back").click(function(){
          $(".menuLink.levelOne").attr('tabindex', 0);  
          $(".menuLink.levelTwo.levelTwoReading").attr('tabindex', 0); 
          $(".menuLink.levelTwo.levelTwoOnline").attr('tabindex', 0);
          $('.menu-sidebar').css('overflow-y', 'auto');
        });


        $(".full-menu-back-online").keyup(function(event) {          
          if (event.keyCode === 13) {
            $(".menuLink.levelOne").attr('tabindex', 0);
            $("#online-menu-expand").attr('tabindex',0);  
            $("#reading-menu-expand").attr('tabindex',0);  
            $(".menuLink.levelTwo.levelTwoReading").attr('tabindex', -1); 
            $(".menuLink.levelTwo.levelTwoOnline").attr('tabindex', -1);
            $('#toggle-online-menu').prop('checked', false);
            $('.menu-sidebar').css('overflow-y', 'auto');
          }
        });

        $(".full-menu-back-readingroom").keyup(function(event) {          
          if (event.keyCode === 13) {
            $(".menuLink.levelOne").attr('tabindex', 0); 
            $("#online-menu-expand").attr('tabindex',0);  
            $("#reading-menu-expand").attr('tabindex',0);  
            $(".menuLink.levelTwo.levelTwoReading").attr('tabindex', -1); 
            $(".menuLink.levelTwo.levelTwoOnline").attr('tabindex', -1);
            $('#toggle-reading-menu').prop('checked', false);
            $('.menu-sidebar').css('overflow-y', 'auto');
          }
        });

        
        $("li.onlineLink:nth-child(15) > a").keyup(function(event) {          
          if (event.keyCode === 9) {
            $(".full-menu-back.full-menu-back-online").focus();
          }
        });

        
        $("li.readingRoomLink:nth-child(29) > a").keyup(function(event) {          
          var elem = $(this);
          if (event.keyCode === 9 && elem.is(":focus")) {
            $(".full-menu-back-readingroom").focus();
          }
        });
};

validate2();

var onlineElements = document.getElementsByClassName('onlineLink');
var readingElements = document.getElementsByClassName('readingRoomLink');

for (var i = 0; i < onlineElements.length; i++) {
hoverintent(onlineElements[i],
function() {
  // Handler in
  var collectionText = this.firstElementChild.textContent;
  document.getElementById('onlineSummary').textContent = collectionText;
  var collecntionImage = this.getElementsByClassName("hiddenImage")[0];
  var imageSrc = collecntionImage.innerHTML;
  var element = document.getElementById("menuImageCollections");
  element.style.backgroundImage =
      "linear-gradient(0deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0) 80%),url('" +
      imageSrc +
      "')";
  

}, function() {
  // Handler out
}).options(opts);

};

for (var i = 0; i < readingElements.length; i++) {
  hoverintent(readingElements[i],
  function() {
    // Handler in
    var collectionText = this.firstElementChild.textContent;
    document.getElementById('readingRoomSummary').textContent = collectionText;
    var collecntionImage = this.getElementsByClassName("hiddenImage")[0];
    var imageSrc = collecntionImage.innerHTML;
    var element = document.getElementById("menuImageReadingRoom");
     element.style.backgroundImage =
         "linear-gradient(0deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0) 80%),url('" +
         imageSrc +
         "')";
  
  }, function() {
    // Handler out
  }).options(opts);
  
}

$('input[name=input]').on('keydown', function (evt) {
    if (evt.key === 'Tab' || evt.key === 'Enter') {
        evt.preventDefault();
        $('input[name=btn]').trigger('click');
    }
});

/* eslint-enable */
